<!--摄像头树-->
<template>
	<baseTree ref="treeBean"  class="treeBody" 
	:dataList="dataList" 
	:multiSelect="multiSelect" 
	:groupCheckAble="groupCheckAble" 
	:autoSelectMethod="autoSelectMethod" 
	:typeImgNameList="typeImgNameList" 
	:getTypeImgIndex="getTypeImgIndex" 
	:isGroup="isGroup" 
	:isSameItem="isSameItem" 
	:isDisAble="isDisAble" 
	:checkShowAble="checkShowAble" 
	:checkImgNameList="checkImgNameList" 
	:getCheckImgIndex="getCheckImgIndex" 
	:baseTreeStyle="baseTreeStyle" 
	:maxSelectedNum="maxSelectedNum"
	 @beyondMaxSelect="$emit('beyondMaxSelect')" 
	 @checkItem="$emit('checkItem', $event)" :getIDMethod="getIDMethod" :stateShowAble="stateShowAble" :getLabelMethod="getLabelMethod">
	</baseTree>
</template>

<script>
	import baseTree from '@/components/module/tree/baseTree.vue'
	import imageView from '@/components/module/universal/imageView.vue'
	export default {
		components: {
			baseTree,
			imageView,
		},
		props: {
			//数据源，可查看设备树或者啥的
			dataList: {
				type: Array,
				required: true,
			},
			//默认选中的方法,接收到数据源的时候，会递归设备树，然后根据这个方法找到第一个符合条件的项，设置为选中项，但是会根据是否允许选中单位来做过滤，如果不允许选中单位组，返回true也无效
			autoSelectMethod: {
				type: Function,
				default (item, index) {
					//默认是找到第一个设备
					return item.type == 'camera'
				}
			},
			//组是否可以选中，如果可以选中的话，点击会触发点击事件
			groupCheckAble: {
				type: Boolean,
				default: false
			},
			getNextMethod: {
				type: Function,
				default (item, index) {
					return item.next
				}
			},
			stateShowAble: {
				type: Function,
				default (item, index) {
					return this.isGroup(item) && !isempty(this.getNextMethod(item))
				}
			},
			getLabelMethod: {
				type: Function,
				default (item) {
					if (this.isGroup(item)) {
						return item.categoryName
					}
					return item.camera_name
				}
			},
			checkShowAble: {
				type: Function,
				default (item, index) {
					return this.groupCheckAble ? (this.multiSelect) : (!this.isGroup(item) && this.multiSelect)
				}
			},
			isDisAble: {
				type: Function,
				default (item) {
					return false
				}
			},
			baseTreeStyle: {
				type: Object,
				default () {
					return {}
				}
			},
			multiSelect: {
				type: Boolean,
				default () {
					return false
				}
			},
			maxSelectedNum: {
				type: Number,
				default () {
					return undefined
				}
			}
		},
		data() {
			return {
				typeImgNameList: [
					'tree/node_unit.png', 'tree/node_class.png', 'tree/node_dev.png',
					'tree/node_unit_select.png', 'tree/node_class_select.png', 'tree/node_dev_select.png'
				],
				checkImgNameList: ['checkBox/checked.png', 'checkBox/unchecked.png']
			}
		},
		created() {},
		mounted() {},
		destroyed() {},
		computed: {},
		watch: {},
		methods: {
			isGroup(item) {
				return item.type == 'Category'
			},
			getIDMethod(item) {
				return item.no
			},
			isSameItem(item, nowItem) {
				if (nowItem == undefined || item == undefined) {
					return item == nowItem
				}
				return JSON.stringify(item) == JSON.stringify(nowItem)
			},
			getTypeImgIndex(item) {
				var treeB  = this.$refs.treeBean 
				if(treeB == undefined ){
					treeB = {}
				}
				var nowData = treeB.nowCheckItem ? treeB.nowCheckItem:this.multiSelect?[]:{}
				if (this.multiSelect) {
					if (nowData.includes(item)) {
						if (!isempty(item.unitid)) {
							return 3
						}
						if (this.isGroup(item)) {
							return 4
						}
						return 5
					} else {
						if (!isempty(item.unitid)) {
							return 0
						}
						if (this.isGroup(item)) {
							return 1
						}
						return 2
					}
				} else {
					if (this.isSameItem(item, nowData)) {
						if (!isempty(item.unitid)) {
							return 3
						}
						if (this.isGroup(item)) {
							return 4
						}
						return 5
					} else {
						if (!isempty(item.unitid)) {
							return 0
						}
						if (this.isGroup(item)) {
							return 1
						}
						return 2
					}
				}
			},
			setNowCheckItem(item) {
				this.$refs.treeBean.nowCheckItem = item
			},
			getCheckImgIndex(item, datas) {
				if (datas == undefined || !this.multiSelect) {
					return 1
				} else {
					return datas.indexOf(item) > -1 ? 0 : 1
				}
			},
		}
	}
</script>

<style scoped>
</style>
